export const CATEGORY_DEFINITIONS = Object.freeze([
  Object.freeze({ id: 'restaurant', displayOrder: 0, type: 'business', table: 'businesses' }),
  Object.freeze({ id: 'cafe', displayOrder: 1, type: 'business', table: 'businesses' }),
  Object.freeze({ id: 'shop', displayOrder: 2, type: 'business', table: 'businesses' }),
  Object.freeze({ id: 'heritage', displayOrder: 3, type: 'place', table: 'places' }),
  Object.freeze({ id: 'nature', displayOrder: 4, type: 'place', table: 'places' }),
  Object.freeze({ id: 'hotel', displayOrder: 5, type: 'business', table: 'businesses' }),
  Object.freeze({ id: 'religious', displayOrder: 6, type: 'place', table: 'places' }),
  Object.freeze({ id: 'health', displayOrder: 7, type: 'business', table: 'businesses' }),
]);

export const CATEGORY_ORDER = Object.freeze(CATEGORY_DEFINITIONS.map(category => category.id));
export const PLACE_CATEGORY_IDS = Object.freeze(
  CATEGORY_DEFINITIONS
    .filter(category => category.type === 'place')
    .map(category => category.id)
);
export const BUSINESS_CATEGORY_IDS = Object.freeze(
  CATEGORY_DEFINITIONS
    .filter(category => category.type === 'business')
    .map(category => category.id)
);

const CATEGORY_BY_ID = CATEGORY_DEFINITIONS.reduce((acc, category) => {
  acc[category.id] = category;
  return acc;
}, {});

export const CATEGORY_TABLES = Object.freeze(
  CATEGORY_DEFINITIONS.reduce((acc, category) => {
    acc[category.id] = category.table;
    return acc;
  }, {})
);

export const DISTRICT_BOUNDS = Object.freeze({
  minLat: 34.24,
  maxLat: 34.43,
  minLng: 35.82,
  maxLng: 36.01,
});

const ZGHARTA_CAZA_BOUNDARY = Object.freeze({"type":"Feature","properties":{"name":"Zgharta District (Caza)","source":"OpenStreetMap relation 317320 via Nominatim","fetched":"2026-08-19","license":"ODbL","bbox":[35.853,34.265,36.032,34.456]},"geometry":{"type":"Polygon","coordinates":[[[35.853265,34.4235834],[35.8545017,34.4216249],[35.855364,34.4200806],[35.8559632,34.4193714],[35.8562923,34.4189227],[35.8565659,34.4183841],[35.8576442,34.416279],[35.8581735,34.4156278],[35.8601639,34.4141402],[35.8619393,34.4099433],[35.8645034,34.4070336],[35.8645733,34.4069892],[35.8661771,34.4059714],[35.8673143,34.4065733],[35.8689666,34.4064671],[35.8701397,34.4055293],[35.8706907,34.404926],[35.8712576,34.4035745],[35.873619,34.4036733],[35.87444,34.4034093],[35.8748327,34.4030652],[35.8749078,34.4022426],[35.874857,34.4020862],[35.8744201,34.4017246],[35.8722404,34.3998489],[35.8715415,34.3984647],[35.8704901,34.3966056],[35.8694815,34.395738],[35.869193,34.3940742],[35.8700394,34.3914708],[35.8690738,34.3901604],[35.8692359,34.3880607],[35.8668637,34.3844408],[35.8664613,34.3791555],[35.863596,34.372795],[35.8593894,34.3656925],[35.8574114,34.3617941],[35.8552996,34.3555864],[35.8545232,34.3469594],[35.8545324,34.3402865],[35.8562207,34.3364022],[35.857645,34.3312136],[35.8592462,34.330484],[35.8599383,34.3294562],[35.8597076,34.3253362],[35.8594823,34.3240692],[35.859456,34.3227641],[35.8596003,34.3217477],[35.8599007,34.3210566],[35.8602762,34.320649],[35.8602977,34.3203122],[35.8600831,34.3197629],[35.8603084,34.3190806],[35.860362,34.3183628],[35.8606839,34.3176805],[35.860523,34.3168298],[35.8601046,34.3166437],[35.8594072,34.3162538],[35.8592248,34.3156867],[35.8590531,34.3140916],[35.8593829,34.3132106],[35.8614403,34.3123149],[35.8616173,34.312018],[35.8617675,34.3117433],[35.8623522,34.3109723],[35.8621806,34.3106533],[35.8618373,34.3103121],[35.8616871,34.3098424],[35.8617675,34.3095765],[35.8622074,34.309129],[35.8624542,34.3086416],[35.8626571,34.3079441],[35.8626258,34.3074806],[35.8634627,34.3069134],[35.863806,34.3060449],[35.8636022,34.3051675],[35.8638704,34.304813],[35.8641815,34.3041838],[35.8648682,34.3037282],[35.8684653,34.2969065],[35.8709193,34.2949883],[35.8711767,34.2943103],[35.8737087,34.2941862],[35.876636,34.2943979],[35.8797383,34.2940266],[35.8809399,34.2936366],[35.8809185,34.2907115],[35.8822707,34.2885495],[35.8847594,34.2880345],[35.8874631,34.2875559],[35.8904457,34.2873786],[35.8945158,34.2864111],[35.9046397,34.2831998],[35.9137768,34.2834482],[35.9199487,34.2799907],[35.9261251,34.2760387],[35.9325409,34.2728274],[35.9414318,34.2715944],[35.9527887,34.2715944],[35.9621742,34.2691261],[35.965381,34.2686315],[35.9662446,34.2684217],[35.974518,34.2664117],[35.9807236,34.2651349],[35.9849882,34.265055],[35.9872198,34.2655338],[35.9893223,34.266862],[35.9953835,34.2697415],[36.0037799,34.2732012],[36.0131608,34.2773971],[36.0185965,34.2825821],[36.0242738,34.283569],[36.0294612,34.2867803],[36.0317873,34.2961937],[36.0297143,34.296574],[36.0284617,34.2971237],[36.0269239,34.2979341],[36.0203241,34.3013485],[36.0166205,34.3035707],[36.010444,34.3062851],[36.0045206,34.3082611],[36.0005685,34.3085096],[35.9961242,34.311967],[35.9919283,34.315919],[35.9901315,34.3170934],[35.9865223,34.3194522],[35.9790877,34.3267814],[35.9719267,34.3314741],[35.9647679,34.3351777],[35.9600751,34.3388791],[35.9558747,34.3425826],[35.9504435,34.3435718],[35.9472345,34.3455478],[35.9447662,34.3485107],[35.9432825,34.3544342],[35.9408142,34.3583862],[35.9335278,34.3674002],[35.9301638,34.3667749],[35.9259581,34.3700605],[35.9214247,34.3721013],[35.9224883,34.3746209],[35.9186411,34.3755508],[35.9193492,34.3773926],[35.9227824,34.3787563],[35.9170809,34.387692],[35.9222192,34.3870304],[35.9252715,34.3920551],[35.9288335,34.3906916],[35.9296274,34.3864596],[35.9325226,34.3859148],[35.9360003,34.3899125],[35.9520399,34.4015896],[35.9419353,34.4064825],[35.9438636,34.4093268],[35.9441727,34.4105876],[35.9446568,34.4121023],[35.9459437,34.4152163],[35.9471091,34.4180175],[35.9488413,34.4217234],[35.9545194,34.4228769],[35.9691363,34.4246343],[35.9707928,34.4259663],[35.9718132,34.4273902],[35.9760189,34.4285406],[35.9721824,34.4318784],[35.9719062,34.436224],[35.9738937,34.4385427],[35.9793869,34.4450757],[35.9754161,34.4484623],[35.9629127,34.4506114],[35.9568786,34.4548372],[35.9514934,34.4516737],[35.9509992,34.4456361],[35.9558057,34.4417076],[35.9503555,34.4371773],[35.9453881,34.4356287],[35.9428239,34.4349031],[35.9403992,34.4341687],[35.9372234,34.4407874],[35.9335607,34.451886],[35.9412946,34.4534785],[35.9315586,34.4555449],[35.9279721,34.4555518],[35.9273488,34.4559986],[35.9215703,34.4559545],[35.9246921,34.4488743],[35.9115872,34.4453293],[35.8994491,34.4484471],[35.8955387,34.4535833],[35.895273,34.453252],[35.8950569,34.4529826],[35.8947048,34.4525436],[35.8937139,34.4518834],[35.8931211,34.4514884],[35.8928082,34.4512728],[35.8912857,34.450224],[35.8898284,34.449556],[35.886614,34.4480431],[35.8848193,34.4464314],[35.8823951,34.4458238],[35.8816487,34.4458395],[35.8812809,34.4458811],[35.8802764,34.446252],[35.8801515,34.4461285],[35.8781165,34.4451259],[35.8770176,34.4446085],[35.8759138,34.4440291],[35.8746401,34.4431379],[35.8735049,34.4424999],[35.873121,34.4423694],[35.8731276,34.4411854],[35.8732773,34.4398985],[35.8734537,34.4390453],[35.8734847,34.4384159],[35.8732832,34.4378318],[35.8729599,34.4371751],[35.8728948,34.436605],[35.8730203,34.4357989],[35.8719301,34.4356135],[35.8713713,34.4357832],[35.8707658,34.4355291],[35.8699149,34.4351028],[35.8695312,34.4350224],[35.8695534,34.4343616],[35.8682179,34.4349016],[35.8679228,34.4350342],[35.8676468,34.4351253],[35.86662,34.435346],[35.8659342,34.4353796],[35.8647277,34.435439],[35.8647325,34.4353763],[35.863586,34.4346789],[35.8624436,34.4339714],[35.861724,34.4325999],[35.8615642,34.4326612],[35.8617467,34.4322334],[35.8620647,34.4318781],[35.8623944,34.4314866],[35.8629872,34.4307707],[35.8636642,34.429962],[35.8637472,34.4298799],[35.8613521,34.4294868],[35.861087,34.4293917],[35.8610077,34.4293644],[35.8610358,34.4292938],[35.860796,34.4292273],[35.8587735,34.4282615],[35.8581515,34.4276765],[35.8536379,34.4258262],[35.853265,34.4235834]]]}});
const BSHARRI_CAZA_BOUNDARY = Object.freeze({"type":"Feature","properties":{"name":"Bsharri District (Caza)","source":"OpenStreetMap relation 317316 via Nominatim","fetched":"2026-08-24","license":"ODbL","bbox":[35.826,34.182,36.103,34.296]},"geometry":{"type":"Polygon","coordinates":[[[35.8260862,34.2655469],[35.8266735,34.2642393],[35.8308527,34.2629861],[35.8332823,34.2596654],[35.8377084,34.2567891],[35.8432353,34.2536964],[35.846328,34.2512622],[35.8465696,34.250248],[35.8464909,34.2498574],[35.8494687,34.2513169],[35.8546378,34.251889],[35.8593442,34.251889],[35.8640529,34.2512007],[35.8693359,34.2490196],[35.8745004,34.2464943],[35.8800114,34.242818],[35.8862106,34.2399486],[35.8910333,34.2361607],[35.8957443,34.2326007],[35.8998763,34.231452],[35.9080191,34.2274864],[35.9408345,34.2210082],[35.9492505,34.2176457],[35.9575653,34.2153866],[35.9633822,34.2156387],[35.9648089,34.2140531],[35.9663017,34.2121044],[35.9710811,34.2088749],[35.9753887,34.207439],[35.9791173,34.2072954],[35.982707,34.2071541],[35.9851456,34.2068624],[35.986153,34.2055747],[35.9854328,34.2035645],[35.983997,34.2022699],[35.982707,34.2001184],[35.9829941,34.1971054],[35.9825634,34.1958131],[35.9809839,34.194808],[35.9786866,34.1940924],[35.977253,34.1920822],[35.977253,34.1905028],[35.9778251,34.1897848],[35.9811298,34.188782],[35.9838556,34.1882054],[35.9881587,34.1850465],[35.9914634,34.1837588],[35.9933277,34.1840437],[35.9949072,34.1856231],[35.9966279,34.1873439],[36.0003589,34.1886361],[36.0020819,34.1909335],[36.0043793,34.1919363],[36.0109819,34.1919363],[36.0141362,34.1919363],[36.0160074,34.1909335],[36.0183025,34.1890669],[36.0214568,34.188782],[36.0259103,34.1890669],[36.0303569,34.1907877],[36.0369595,34.1919363],[36.0418791,34.1818703],[36.0557699,34.2063316],[36.0735784,34.221164],[36.0753698,34.2249291],[36.0778837,34.2313927],[36.0848806,34.2369538],[36.089366,34.2437707],[36.0949293,34.2520212],[36.0994101,34.2566866],[36.1009498,34.2622512],[36.1027811,34.2642837],[36.0853213,34.2694651],[36.0796495,34.2779008],[36.0718416,34.2873195],[36.0630895,34.2904196],[36.0542162,34.2928125],[36.0489623,34.29398],[36.0434645,34.2948468],[36.0392892,34.2955731],[36.0317873,34.2961937],[36.0294612,34.2867803],[36.0242738,34.283569],[36.0185965,34.2825821],[36.0131608,34.2773971],[36.0037799,34.2732012],[35.9953835,34.2697415],[35.9893223,34.266862],[35.9872198,34.2655338],[35.9849882,34.265055],[35.9807236,34.2651349],[35.974518,34.2664117],[35.9662446,34.2684217],[35.965381,34.2686315],[35.9621742,34.2691261],[35.9527887,34.2715944],[35.9414318,34.2715944],[35.9325409,34.2728274],[35.9261251,34.2760387],[35.9199487,34.2799907],[35.9137768,34.2834482],[35.9046397,34.2831998],[35.8945158,34.2864111],[35.8904457,34.2873786],[35.8874631,34.2875559],[35.8847594,34.2880345],[35.8822707,34.2885495],[35.8809185,34.2907115],[35.8809399,34.2936366],[35.8797383,34.2940266],[35.876636,34.2943979],[35.8737087,34.2941862],[35.8711767,34.2943103],[35.8709193,34.2949883],[35.8695127,34.2934804],[35.870254,34.2910129],[35.8716908,34.2897474],[35.8676393,34.2884619],[35.8673358,34.2878307],[35.8686662,34.2868024],[35.8706395,34.2863631],[35.8707905,34.2852688],[35.8701253,34.2837441],[35.8701467,34.281652],[35.8702719,34.2792461],[35.8677822,34.2778503],[35.8678518,34.2759908],[35.8671856,34.2749675],[35.8655829,34.2754766],[35.8627867,34.2723964],[35.8585471,34.2657238],[35.8548903,34.2666865],[35.8549547,34.2681583],[35.8535385,34.2686371],[35.8493542,34.2690805],[35.8458566,34.2693642],[35.8425339,34.2746315],[35.8411574,34.2753753],[35.8375308,34.2704268],[35.8314278,34.2726694],[35.8304199,34.2734685],[35.8287518,34.2715307],[35.8267878,34.2723898],[35.8262878,34.269615],[35.8260862,34.2655469]]]}});


export const GOOGLE_PLACE_TYPE_CATEGORY_MAP = Object.freeze({
  religious: Object.freeze(['place_of_worship', 'church', 'mosque']),
  nature: Object.freeze(['park', 'natural_feature', 'campground', 'hiking_area']),
  heritage: Object.freeze(['museum', 'tourist_attraction', 'library', 'art_gallery']),
  restaurant: Object.freeze(['restaurant', 'meal_delivery', 'meal_takeaway', 'food']),
  hotel: Object.freeze(['lodging', 'hotel', 'motel', 'guest_house']),
  cafe: Object.freeze(['cafe', 'bar', 'night_club']),
  shop: Object.freeze([
    'store',
    'shopping_mall',
    'supermarket',
    'grocery_or_supermarket',
    'clothing_store',
    'book_store',
    'convenience_store',
    'home_goods_store',
    'jewelry_store',
    'shoe_store',
  ]),
});

export const GOOGLE_TYPE_PRIORITY = Object.freeze([
  'religious',
  'nature',
  'heritage',
  'hotel',
  'cafe',
  'restaurant',
  'shop',
]);

export const EXCLUDED_GOOGLE_PLACE_TYPES = Object.freeze([
  'gas_station',
  'atm',
  'bank',
  'post_office',
  'police',
  'fire_station',
  'courthouse',
  'local_government_office',
  'parking',
  'car_wash',
  'car_repair',
  'car_dealer',
  'insurance_agency',
  'lawyer',
  'accounting',
  'moving_company',
  'storage',
  'electrician',
  'plumber',
  'roofing_contractor',
  'painter',
  'locksmith',
  'laundry',
  'funeral_home',
  'cemetery',
]);

const KNOWN_VILLAGE_DEFINITIONS = Object.freeze([
  { name: 'Aarbet Qozhaya', aliases: ['Arbet Qozhaya'], lat: 34.2840, lng: 35.9449, caza: 'zgharta' },
  { name: 'Haref El Fouar', caza: 'zgharta' },
  { name: 'Harf Ardeh', lat: 34.3988, lng: 35.9130, caza: 'zgharta' },
  { name: 'Bqaa Safrin', lat: 34.3500, lng: 35.9600 },
  { name: 'Beit Aouker', caza: 'zgharta' },
  { name: 'Tallet Zgharta', caza: 'zgharta' },
  { name: 'Karm Saddeh', caza: 'zgharta' },
  { name: 'Kfar Beit' },
  { name: 'Kfardlakos', lat: 34.3850, lng: 35.8950, caza: 'zgharta' },
  { name: 'Kfarhata', aliases: ['Kfar Hatta'], lat: 34.3750, lng: 35.8850, caza: 'zgharta' },
  { name: 'Kfarshakhna', caza: 'zgharta' },
  { name: 'Kfar Zeina', aliases: ['Kfar Zina', 'Kfarzina', 'Kferzeina'], caza: 'zgharta' },
  { name: 'Kfarsghab', lat: 34.3178, lng: 35.9956, caza: 'zgharta' },
  { name: 'Mejdlaya', aliases: ['Majdlaiya'], lat: 34.4050, lng: 35.9050, caza: 'zgharta' },
  { name: 'Basloukit', lat: 34.3150, lng: 35.9500, caza: 'zgharta' },
  { name: 'Bkeftine' },
  { name: 'Bnachii', aliases: ['Bnachei'], lat: 34.3365, lng: 35.8868, caza: 'zgharta' },
  { name: 'Raskifa', caza: 'zgharta' },
  { name: 'Rachiine', lat: 34.3900, lng: 35.8800, caza: 'zgharta' },
  { name: 'Miziara', lat: 34.3310, lng: 35.9100, caza: 'zgharta' },
  { name: 'Aachach', caza: 'zgharta' },
  { name: 'Ardeh', aliases: ['Aardeh', 'Aardat'], lat: 34.4131, lng: 35.9119, caza: 'zgharta' },
  { name: 'Asnoun', lat: 34.3880, lng: 35.8780, caza: 'zgharta' },
  { name: 'Miryata', lat: 34.3400, lng: 35.9200, caza: 'zgharta' },
  { name: 'Daraya', caza: 'zgharta' },
  { name: 'Ehden', lat: 34.3050, lng: 35.9870, caza: 'zgharta' },
  { name: 'Hawqa', aliases: ['Haouqa', 'Houqa'], caza: 'zgharta' },
  { name: 'Zgharta', aliases: ['Zghorta'], lat: 34.3998, lng: 35.8923, caza: 'zgharta' },
  { name: 'Alma', caza: 'zgharta' },
  { name: 'Aito', lat: 34.2900, lng: 35.9500, caza: 'zgharta' },
  { name: 'Bsharri', aliases: ['Bcharre', 'Bcharri', 'Bcharreh'], lat: 34.2512, lng: 36.0120, caza: 'bsharri' },
  { name: 'Amioun' },
  { name: 'Kousba' },
]);

export const KNOWN_VILLAGES = Object.freeze(KNOWN_VILLAGE_DEFINITIONS.map(village => village.name));
export const KNOWN_VILLAGE_CENTERS = Object.freeze(
  KNOWN_VILLAGE_DEFINITIONS
    .filter(village => village.lat != null && village.lng != null)
    .map(village => Object.freeze({
      name: village.name,
      lat: village.lat,
      lng: village.lng,
    }))
);

export const OUT_OF_DISTRICT_NAMES = Object.freeze([
  'tripoli',
  'tripoly',
  'batroun',
  'bsharri',
  'bcharre',
  'bcharri',
  'bcharreh',
  'bqerqacha',
  'barsa',
  'dahr el ain',
  'dimane',
  'hadath el jebbeh',
  'hasroun',
  'qannoubin',
  'qanoubin',
  'annoubin',
  'blaouza',
  'blawza',
  'qnat',
  'koura',
  'akkar',
  'miniyeh',
  'minieh',
  'danniyeh',
  'dinniyeh',
  'beirut',
  'jounieh',
  'jbeil',
  'byblos',
  'saida',
  'sidon',
  'tyre',
  'sour',
]);

export const PLUS_CODE_RE = /\b[A-Z0-9]{4,}\+[A-Z0-9]{2,}\b/i;
const COUNTRY_OR_REGION_RE = /^(lebanon|north governorate|north lebanon|zgharta district|zgharta caza)$/i;

export const CATALOG_CAZA_ZGHARTA = 'zgharta';
export const CATALOG_CAZA_BSHARRI = 'bsharri';
export const CATALOG_CAZA_LABELS = Object.freeze({
  zgharta: Object.freeze({ en: 'Zgharta Caza', ar: 'قضاء زغرتا' }),
  bsharri: Object.freeze({ en: 'Bsharri Caza', ar: 'قضاء بشري' }),
});
export const CATALOG_CAZA_SHORT_LABELS = Object.freeze({
  zgharta: Object.freeze({ en: 'Zgharta', ar: 'زغرتا' }),
  bsharri: Object.freeze({ en: 'Bsharri', ar: 'بشري' }),
});
export const CATALOG_CAZA_NEUTRAL_LABELS = Object.freeze({
  en: 'North Lebanon',
  ar: 'شمال لبنان',
});
const ZGHARTA_ONLY_FORBIDDEN_CLAIM_IDS = new Set([
  'cedars_bsharri_claim',
  'bsharri_caza_claim',
  'qannoubine_mar_lichaa_claim',
  'bane_claim',
]);
const BSHARRI_CAZA_LOCALITY_NAMES = Object.freeze([
  'bsharri',
  'bcharre',
  'bcharri',
  'bcharreh',
  'bqerqacha',
  'dimane',
  'hadath el jebbeh',
  'hasroun',
  'qannoubin',
  'qanoubin',
  'annoubin',
  'blaouza',
  'blawza',
  'qnat',
]);
const FOREIGN_TO_BOTH_CAZA_NAMES = Object.freeze(
  OUT_OF_DISTRICT_NAMES.filter(name => !BSHARRI_CAZA_LOCALITY_NAMES.includes(name))
);

export function normalizeCatalogCaza(value) {
  if (value == null) return null;
  const normalized = String(value).trim().toLowerCase();
  if (normalized === CATALOG_CAZA_ZGHARTA || normalized === CATALOG_CAZA_BSHARRI) return normalized;
  return null;
}

export function catalogCazaLabel(caza, lang = 'en') {
  const id = normalizeCatalogCaza(caza);
  if (!id) return null;
  const labels = CATALOG_CAZA_LABELS[id];
  return lang === 'ar' ? labels.ar : labels.en;
}

export function catalogCazaShortLabel(caza, lang = 'en') {
  const id = normalizeCatalogCaza(caza);
  if (!id) return null;
  const labels = CATALOG_CAZA_SHORT_LABELS[id];
  return lang === 'ar' ? labels.ar : labels.en;
}

export function catalogCazaLabelOrNeutral(caza, lang = 'en') {
  return catalogCazaLabel(caza, lang) || (lang === 'ar' ? CATALOG_CAZA_NEUTRAL_LABELS.ar : CATALOG_CAZA_NEUTRAL_LABELS.en);
}

export function catalogCazaShortLabelOrNeutral(caza, lang = 'en') {
  return catalogCazaShortLabel(caza, lang) || (lang === 'ar' ? CATALOG_CAZA_NEUTRAL_LABELS.ar : CATALOG_CAZA_NEUTRAL_LABELS.en);
}

export function sharedCatalogCaza(items) {
  if (!Array.isArray(items) || items.length === 0) return null;
  const ids = [];
  for (const item of items) {
    const id = normalizeCatalogCaza(item?.caza);
    if (!id) return null;
    if (!ids.includes(id)) ids.push(id);
  }
  return ids.length === 1 ? ids[0] : null;
}

export const BOUNDARY_CLEANUP_ACTIONS = Object.freeze([
  'keep',
  'rename_village',
  'manual_boundary_review',
  'soft_deactivate',
  'blocklist',
]);
export const PUBLIC_LOCALITY_UNDER_REVIEW_LABELS = Object.freeze({
  en: 'Location to confirm',
  ar: 'الموقع قيد التأكيد',
});
export const PUBLIC_LOCALITY_UNDER_REVIEW_EDITORIAL_LABEL = 'Location to confirm';

export const FORBIDDEN_BOUNDARY_CLAIM_RULES = Object.freeze([
  Object.freeze({
    id: 'cedars_bsharri_claim',
    label: 'Cedars/Bsharri-side cedar claim',
    // Arabic forms added after a cold review found the Latin-only matcher bypassable by the
    // Arabic spelling, which appears in real bilingual listings.
    matcher: /\b(cedars?\s+of\s+god|forest\s+of\s+the\s+cedars?\s+of\s+god|arz\s*(?:el|al)?\s*rab|cedars?\s+hill|cedres?\s+de\s+dieu)\b|أرز\s*ال?رب|ارز\s*ال?رب|غابة\s*الأرز/i,
  }),
  Object.freeze({
    id: 'bsharri_caza_claim',
    label: 'Bsharri caza place name',
    // Accented French (Bécharré, Bcharré) and Arabic (بشري / بشرّي) forms included.
    matcher: /\b(bsharri|bsharre|bcharre|bcharri|bcharreh|becharre|bécharré|bcharré)\b|بشري|بشرّي|بشرِّي/i,
  }),
  Object.freeze({
    id: 'qannoubine_mar_lichaa_claim',
    label: 'Qannoubine/Mar Lichaa or Mar Elisha claim',
    // The leading Q is dropped in common transliterations ("Wadi Annoubine", "Blawza
    // Annoubine Hike"). A live event listing using exactly that spelling passed this matcher
    // on 2026-08-23 during the #347 ingest work, so the Q-less forms are matched too.
    // Arabic forms added after a cold review found the Latin-only matcher bypassable.
    matcher: /\b(qannoubin(?:e)?|qanoubin(?:e)?|kanoubin(?:e)?|annoubin(?:e)?|anoubin(?:e)?|mar\s+lichaa|mar\s+elisha|st\.?\s*elisha)\b|قنوبين|قزحيا\s*بشري|مار\s*ليشع/i,
  }),
  Object.freeze({
    id: 'bane_claim',
    label: 'Bane place name',
    matcher: /\bbane\b/i,
  }),
  Object.freeze({
    id: 'hamatoura_claim',
    label: 'Hamatoura claim',
    matcher: /\bhamatoura\b/i,
  }),
]);

const BROAD_QADISHA_CLAIM_RE = /\b(?:kadisha|qadisha)\b|\bholy\s+valley\b/i;
const QADISHA_FRONTAGE_ALLOW_RE = /\b(qozhaya|qozhaiya|qozhaya-side|zgharta-side|haouqa|houqa)\b/i;
export const SUSPICIOUS_VILLAGE_LABEL_RE =
  /\b(unnamed\s+road|main\s+road|main\s*street|nabeh\s+jouiit\s+rd|francois\s+jabbour\s+chidiac|north\s+lebanon|cedar\s+highway|road|rd\.?|street|highway)\b|^near\s+/i;

function normalizeText(value) {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase();
}

function boundaryText(itemOrText) {
  if (itemOrText == null) return '';
  if (typeof itemOrText === 'string') return itemOrText;
  return [
    itemOrText.name,
    itemOrText.nameAr,
    itemOrText.name_ar,
    itemOrText.description,
    itemOrText.descriptionAr,
    itemOrText.description_ar,
    itemOrText.village,
    itemOrText.villageAr,
    itemOrText.village_ar,
    itemOrText.location,
    itemOrText.locationAr,
    itemOrText.location_ar,
  ].filter(Boolean).join(' ');
}

const VILLAGE_MATCHERS = KNOWN_VILLAGE_DEFINITIONS.flatMap(village => {
  const aliases = village.aliases || [];
  return [village.name, ...aliases].map(alias => ({
    alias,
    normalizedAlias: normalizeText(alias),
    name: village.name,
  }));
}).sort((a, b) => b.normalizedAlias.length - a.normalizedAlias.length);

export function getCategory(categoryId) {
  return CATEGORY_BY_ID[categoryId] || null;
}

export function getCategoryOrder() {
  return CATEGORY_ORDER.slice();
}

export function getCategoryType(categoryId) {
  const category = getCategory(categoryId);
  return category ? category.type : null;
}

export function getCategoryTable(categoryId) {
  const category = getCategory(categoryId);
  return category ? category.table : null;
}

export function isPlaceCategory(categoryId) {
  return getCategoryType(categoryId) === 'place';
}

export function isBusinessCategory(categoryId) {
  return getCategoryType(categoryId) === 'business';
}

export function getCategoryIdsForType(type) {
  if (type === 'place') return PLACE_CATEGORY_IDS.slice();
  if (type === 'business') return BUSINESS_CATEGORY_IDS.slice();
  return [];
}

export function hasExcludedGooglePlaceType(types) {
  const typeSet = new Set(Array.isArray(types) ? types : []);
  return EXCLUDED_GOOGLE_PLACE_TYPES.some(type => typeSet.has(type));
}

function hasAnyType(typeSet, candidates) {
  return candidates.some(type => typeSet.has(type));
}

export function classifyGooglePlaceTypes(types) {
  const typeSet = new Set(Array.isArray(types) ? types : []);

  for (const categoryId of GOOGLE_TYPE_PRIORITY) {
    const googleTypes = GOOGLE_PLACE_TYPE_CATEGORY_MAP[categoryId];
    if (!hasAnyType(typeSet, googleTypes)) continue;

    if (categoryId === 'restaurant' && typeSet.has('bakery') && !typeSet.has('restaurant')) {
      const hasShopType = hasAnyType(typeSet, GOOGLE_PLACE_TYPE_CATEGORY_MAP.shop);
      if (hasShopType) continue;
    }

    if (categoryId === 'heritage' && typeSet.has('tourist_attraction')) {
      const isFood = hasAnyType(typeSet, ['restaurant', 'food', 'cafe', 'bar']);
      const isLodging = hasAnyType(typeSet, ['lodging', 'hotel']);
      if (isFood || isLodging) continue;
    }

    return categoryId;
  }

  if (typeSet.has('bakery')) return 'shop';
  return null;
}

export function isWithinDistrictBounds(lat, lng, bounds = DISTRICT_BOUNDS) {
  if (lat == null || lng == null) return false;
  const numericLat = Number(lat);
  const numericLng = Number(lng);
  if (!Number.isFinite(numericLat) || !Number.isFinite(numericLng)) return false;
  return numericLat >= bounds.minLat &&
    numericLat <= bounds.maxLat &&
    numericLng >= bounds.minLng &&
    numericLng <= bounds.maxLng;
}

export function isCoordinateInDistrict(coords, bounds = DISTRICT_BOUNDS) {
  if (!coords) return false;
  return isWithinDistrictBounds(coords.lat, coords.lng, bounds);
}

export function isOutsideDistrictBounds(item, bounds = DISTRICT_BOUNDS) {
  if (!item) return false;
  const lat = item.latitude != null ? item.latitude : item.lat;
  const lng = item.longitude != null ? item.longitude : item.lng;
  if (lat == null || lng == null) return false;
  return !isWithinDistrictBounds(lat, lng, bounds);
}

export function isPlusCode(value) {
  return PLUS_CODE_RE.test(String(value || '').trim());
}

export function findKnownVillage(value) {
  const normalized = normalizeText(value);
  if (!normalized) return null;

  const match = VILLAGE_MATCHERS.find(village => normalized.includes(village.normalizedAlias));
  return match ? match.name : null;
}

export function isKnownVillage(value) {
  return findKnownVillage(value) != null;
}

export function getKnownVillageCenter(value) {
  const villageName = findKnownVillage(value);
  if (!villageName) return null;
  const center = KNOWN_VILLAGE_CENTERS.find(village => village.name === villageName);
  return center ? { ...center } : null;
}

export function getKnownVillageCenters() {
  return KNOWN_VILLAGE_CENTERS.map(center => ({ ...center }));
}

export function findKnownVillageCaza(value) {
  const villageName = findKnownVillage(value);
  if (!villageName) return null;
  const definition = KNOWN_VILLAGE_DEFINITIONS.find(village => village.name === villageName);
  return normalizeCatalogCaza(definition?.caza);
}

function catalogCazaPolygons(caza) {
  const id = normalizeCatalogCaza(caza);
  const feature = id === CATALOG_CAZA_BSHARRI
    ? BSHARRI_CAZA_BOUNDARY
    : id === CATALOG_CAZA_ZGHARTA
      ? ZGHARTA_CAZA_BOUNDARY
      : null;
  if (!feature?.geometry) return [];
  if (feature.geometry.type === 'Polygon') return [feature.geometry.coordinates];
  if (feature.geometry.type === 'MultiPolygon') return feature.geometry.coordinates || [];
  return [];
}

function pointInRing(lat, lng, ring) {
  let inside = false;
  for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
    const xi = ring[i][0];
    const yi = ring[i][1];
    const xj = ring[j][0];
    const yj = ring[j][1];
    const intersects = (yi > lat) !== (yj > lat)
      && lng < ((xj - xi) * (lat - yi)) / (yj - yi) + xi;
    if (intersects) inside = !inside;
  }
  return inside;
}

function pointInPolygonCoords(lat, lng, polygonCoords) {
  if (!polygonCoords?.[0]) return false;
  if (!pointInRing(lat, lng, polygonCoords[0])) return false;
  for (let i = 1; i < polygonCoords.length; i += 1) {
    if (pointInRing(lat, lng, polygonCoords[i])) return false;
  }
  return true;
}

export function isCoordinateInCatalogCaza(lat, lng, caza) {
  const numericLat = Number(lat);
  const numericLng = Number(lng);
  if (!Number.isFinite(numericLat) || !Number.isFinite(numericLng)) return false;
  return catalogCazaPolygons(caza).some(polygon => pointInPolygonCoords(numericLat, numericLng, polygon));
}

function otherCatalogCaza(caza) {
  const id = normalizeCatalogCaza(caza);
  if (id === CATALOG_CAZA_ZGHARTA) return CATALOG_CAZA_BSHARRI;
  if (id === CATALOG_CAZA_BSHARRI) return CATALOG_CAZA_ZGHARTA;
  return null;
}

export function distanceKm(a, b) {
  if (!a || !b) return Infinity;
  const lat1 = Number(a.lat);
  const lng1 = Number(a.lng);
  const lat2 = Number(b.lat);
  const lng2 = Number(b.lng);
  if (![lat1, lng1, lat2, lng2].every(Number.isFinite)) return Infinity;

  const toRad = degrees => (degrees * Math.PI) / 180;
  const earthRadiusKm = 6371;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const sinLat = Math.sin(dLat / 2);
  const sinLng = Math.sin(dLng / 2);
  const h = sinLat * sinLat +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * sinLng * sinLng;
  return 2 * earthRadiusKm * Math.asin(Math.min(1, Math.sqrt(h)));
}

export function findNearestKnownVillage(lat, lng) {
  if (lat == null || lng == null || lat === '' || lng === '') return null;
  const numericLat = Number(lat);
  const numericLng = Number(lng);
  if (!Number.isFinite(numericLat) || !Number.isFinite(numericLng)) return null;

  let nearest = null;
  let nearestDistance = Infinity;
  for (const center of KNOWN_VILLAGE_CENTERS) {
    const distance = distanceKm({ lat: numericLat, lng: numericLng }, center);
    if (distance < nearestDistance) {
      nearestDistance = distance;
      nearest = center.name;
    }
  }

  return nearest;
}

export function extractVillage(formattedAddress) {
  if (!formattedAddress) return 'Unknown';

  const parts = String(formattedAddress)
    .split(',')
    .map(part => part.trim())
    .filter(Boolean);

  for (const part of parts) {
    const knownVillage = findKnownVillage(part);
    if (knownVillage) return knownVillage;
  }

  const fallbackParts = parts.filter(part => {
    if (isPlusCode(part)) return false;
    return !COUNTRY_OR_REGION_RE.test(part);
  });

  if (fallbackParts.length >= 2) return fallbackParts[fallbackParts.length - 1];
  if (fallbackParts.length === 1) return fallbackParts[0];
  return 'Unknown';
}

export function isOutOfDistrictVillage(village, caza) {
  if (!village) return false;
  const normalized = normalizeText(village);
  if (!normalized) return false;
  if (isPlusCode(village)) return true;

  const selected = normalizeCatalogCaza(caza);
  if (!selected) {
    return OUT_OF_DISTRICT_NAMES.some(name => normalized.includes(name));
  }

  if (FOREIGN_TO_BOTH_CAZA_NAMES.some(name => normalized.includes(name))) return true;
  const villageCaza = findKnownVillageCaza(village);
  if (villageCaza && villageCaza !== selected) return true;
  if (selected === CATALOG_CAZA_ZGHARTA && BSHARRI_CAZA_LOCALITY_NAMES.some(name => normalized.includes(name))) {
    return true;
  }
  return false;
}

// Fold Latin diacritics so accented French spellings reach the ASCII patterns. A cold review
// found "Bécharré" and "Cèdres de Dieu" bypassing the matcher: JS \b does not treat "é" as a
// word character, so a trailing \b after an accented letter never fires. Arabic is left as-is
// and matched by its own spellings.
function foldDiacritics(text) {
  // Latin accents AND Arabic vowel points. A cold review found vocalized Arabic
  // ("بِشَرِّي", "أَرْزُ الرَّبّ") bypassing rules that matched the unvocalized spelling.
  return String(text)
    .normalize('NFD')
    .replace(/[\u0300-\u036f\u064b-\u065f\u0670]/g, '');
}

export function isForbiddenBoundaryClaim(itemOrText) {
  const text = boundaryText(itemOrText);
  const folded = foldDiacritics(text);
  return FORBIDDEN_BOUNDARY_CLAIM_RULES.some(
    rule => rule.matcher.test(text) || rule.matcher.test(folded)
  );
}

export function isSuspiciousVillageLabel(value) {
  const village = String(value || '').trim();
  if (!village) return false;
  if (isPlusCode(village)) return true;
  return SUSPICIOUS_VILLAGE_LABEL_RE.test(village);
}

export function isUnverifiedVillageLabel(value) {
  const village = String(value || '').trim();
  if (!village) return false;
  if (isKnownVillage(village)) return false;
  if (isOutOfDistrictVillage(village)) return false;
  if (isSuspiciousVillageLabel(village)) return false;
  if (COUNTRY_OR_REGION_RE.test(village)) return false;
  return true;
}

export function hasBroadQadishaClaim(itemOrText) {
  const text = boundaryText(itemOrText);
  if (!BROAD_QADISHA_CLAIM_RE.test(text)) return false;
  return !QADISHA_FRONTAGE_ALLOW_RE.test(text);
}

function getItemLatLng(item) {
  if (!item) return { lat: null, lng: null };
  const coordinates = item.coordinates || {};
  const lat = item.latitude != null ? item.latitude : coordinates.lat;
  const lng = item.longitude != null ? item.longitude : coordinates.lng;
  return { lat, lng };
}

function pushFinding(findings, finding) {
  if (findings.some(existing => existing.id === finding.id)) return;
  findings.push(finding);
}

export function getCatalogBoundaryFindings(item) {
  const findings = [];
  const text = boundaryText(item);
  const foldedText = foldDiacritics(text);
  const selectedCaza = normalizeCatalogCaza(item?.caza);
  const applyZghartaOnlyClaims = selectedCaza !== CATALOG_CAZA_BSHARRI;

  if (!selectedCaza) {
    pushFinding(findings, {
      id: 'unknown_catalog_caza',
      kind: 'unknown_catalog_caza',
      label: 'Missing or unknown catalog caza',
      action: 'soft_deactivate',
    });
  }

  for (const rule of FORBIDDEN_BOUNDARY_CLAIM_RULES) {
    if (!applyZghartaOnlyClaims && ZGHARTA_ONLY_FORBIDDEN_CLAIM_IDS.has(rule.id)) continue;
    if (!rule.matcher.test(text) && !rule.matcher.test(foldedText)) continue;
    pushFinding(findings, {
      id: rule.id,
      kind: 'forbidden_claim',
      label: rule.label,
      action: 'blocklist',
    });
  }

  if (applyZghartaOnlyClaims && hasBroadQadishaClaim(item)) {
    pushFinding(findings, {
      id: 'broad_qadisha_claim',
      kind: 'broad_boundary_claim',
      label: 'Broad Qadisha/Kadisha claim without Zgharta-side frontage framing',
      action: 'manual_boundary_review',
    });
  }

  const locality = item?.village || item?.location || '';
  if (isOutOfDistrictVillage(locality, selectedCaza || CATALOG_CAZA_ZGHARTA)) {
    pushFinding(findings, {
      id: 'out_of_district_locality',
      kind: 'out_of_district_locality',
      label: 'Out-of-district village/location label',
      action: 'soft_deactivate',
    });
  }

  if (isSuspiciousVillageLabel(locality)) {
    pushFinding(findings, {
      id: 'suspicious_village_label',
      kind: 'suspicious_village_label',
      label: 'Suspicious village/location label; likely road or region label',
      action: 'rename_village',
    });
  }

  if (isUnverifiedVillageLabel(locality)) {
    pushFinding(findings, {
      id: 'unverified_village_label',
      kind: 'unverified_village_label',
      label: 'Village/location label is not in the verified Zgharta Caza village list',
      action: 'manual_boundary_review',
    });
  }

  const { lat, lng } = getItemLatLng(item);
  if (lat != null && lng != null && Number.isFinite(Number(lat)) && Number.isFinite(Number(lng))) {
    if (selectedCaza) {
      const inSelected = isCoordinateInCatalogCaza(lat, lng, selectedCaza);
      if (!inSelected) {
        const villageCaza = findKnownVillageCaza(locality);
        const otherCaza = otherCatalogCaza(selectedCaza);
        const villageWinsNearSharedBoundary = Boolean(
          villageCaza === selectedCaza
          && otherCaza
          && isCoordinateInCatalogCaza(lat, lng, otherCaza)
        );
        if (!villageWinsNearSharedBoundary) {
          pushFinding(findings, {
            id: 'coordinates_outside_district',
            kind: 'coordinates_outside_district',
            label: selectedCaza === CATALOG_CAZA_BSHARRI
              ? 'Coordinates outside Bsharri district polygon'
              : 'Coordinates outside Zgharta district polygon',
            action: 'soft_deactivate',
          });
        }
      }
    } else if (!isWithinDistrictBounds(lat, lng)) {
      pushFinding(findings, {
        id: 'coordinates_outside_district',
        kind: 'coordinates_outside_district',
        label: 'Coordinates outside Zgharta district bounds',
        action: 'soft_deactivate',
      });
    }
  }

  return findings;
}

export function classifyBoundaryCleanupAction(item) {
  const findings = getCatalogBoundaryFindings(item);
  const actionSet = new Set();

  if (findings.length === 0) {
    actionSet.add('keep');
  }

  for (const finding of findings) {
    if (finding.action === 'blocklist') {
      actionSet.add('blocklist');
      actionSet.add('soft_deactivate');
      continue;
    }
    actionSet.add(finding.action);
    if (finding.action === 'rename_village') {
      actionSet.add('manual_boundary_review');
    }
  }

  if (actionSet.has('soft_deactivate')) {
    actionSet.add('manual_boundary_review');
  }

  return {
    actions: BOUNDARY_CLEANUP_ACTIONS.filter(action => actionSet.has(action)),
    findings,
  };
}

function isBlockingBoundaryFinding(finding) {
  return [
    'forbidden_claim',
    'broad_boundary_claim',
    'out_of_district_locality',
    'coordinates_outside_district',
    'unknown_catalog_caza',
  ].includes(finding?.kind);
}

export function isPublicZghartaCatalogItem(item) {
  const classification = classifyBoundaryCleanupAction(item);
  if (classification.actions.includes('blocklist') || classification.actions.includes('soft_deactivate')) {
    return false;
  }
  return !classification.findings.some(isBlockingBoundaryFinding);
}

function needsLocalityReviewPresentation(classification) {
  return classification?.findings?.some(finding => (
    finding.kind === 'suspicious_village_label' ||
    finding.kind === 'unverified_village_label'
  ));
}

function findDisplayableVillageFromListingText(item) {
  return findKnownVillage([
    item?.name,
    item?.nameAr,
    item?.name_ar,
    item?.description,
    item?.descriptionAr,
    item?.description_ar,
  ].filter(Boolean).join(' '));
}

function findDisplayableVillageFromCoordinates(item) {
  const { lat, lng } = getItemLatLng(item);
  if (!isWithinDistrictBounds(lat, lng)) return null;

  const nearest = findNearestKnownVillage(lat, lng);
  if (!nearest || isOutOfDistrictVillage(nearest)) return null;
  return nearest;
}

export function getPublicCatalogLocalityPresentation(item) {
  const classification = classifyBoundaryCleanupAction(item);
  if (!needsLocalityReviewPresentation(classification)) {
    return {
      needsReview: false,
      filterable: true,
      village: item?.village,
      villageAr: item?.villageAr || item?.village_ar,
      rawVillage: item?.village,
      rawVillageAr: item?.villageAr || item?.village_ar,
      actions: [],
      reasons: [],
    };
  }

  const displayVillage = findDisplayableVillageFromListingText(item) ||
    findDisplayableVillageFromCoordinates(item) ||
    PUBLIC_LOCALITY_UNDER_REVIEW_LABELS.en;
  return {
    needsReview: true,
    filterable: false,
    village: displayVillage,
    villageAr: displayVillage === PUBLIC_LOCALITY_UNDER_REVIEW_LABELS.en
      ? PUBLIC_LOCALITY_UNDER_REVIEW_LABELS.ar
      : (item?.villageAr || item?.village_ar || displayVillage),
    rawVillage: item?.village,
    rawVillageAr: item?.villageAr || item?.village_ar,
    actions: classification.actions.filter(action => action !== 'keep'),
    reasons: classification.findings.map(finding => finding.label),
  };
}
